// @ts-strict-ignore
import type {
  Action,
  DataRoute,
  LegacyDataRoute,
  ObjectIdReverseTransformationMap,
} from '../../../types';
import { reverseTransformMLAAttributeComponents } from '../rules/rules';

export function getActionName({
  sourceAction,
}: {
  sourceAction: Action;
}) {
  let sourceActionName = '';
  switch (sourceAction.type) {
    case 'tag':
      sourceActionName = sourceAction.tag.name;
      break;
    case 'service':
      sourceActionName = sourceAction.service.name;
      break;
    case 'input':
      sourceActionName = sourceAction.input.name;
      break;
    case 'output':
      sourceActionName = sourceAction.output.name;
      break;
    case 'outcome':
      sourceActionName = sourceAction.outcome.name;
      break;
  }

  return sourceActionName;
}

export function getActionDataForDataRoute({
  action,
  actionId,
}: {
  action: Action;
  actionId: number;
}) {
  return {
    ids: [actionId],
    actionClass: ` ${action.type}`,
    col: 0,
    name: getActionName({ sourceAction: action }),
    row: 0,
    tagColor: action.type === 'tag' ? action.tag.color : null,
    type: action.type,
  };
}

export function reverseTransformJsonDataRoutesToLegacyDataRoutes({
  actions,
  dataRoutes,
  transformedActionsToLegacyActionsIdMap,
}: {
  actions: Action[];
  dataRoutes: DataRoute[];
  transformedActionsToLegacyActionsIdMap: ObjectIdReverseTransformationMap;
}) {
  const transformedLegacyDataRoutes = [];
  const transformedDataRoutesToLegacyDataRoutesIdMap = {};

  Object.entries(
    dataRoutes,
  ).forEach(([dataRouteKey, dataRouteValue], index) => {
    const sourceAction = actions[dataRouteValue.sourceId];
    const targetAction = actions[dataRouteValue.targetId];
    const sourceActionId = Number(transformedActionsToLegacyActionsIdMap[dataRouteValue.sourceId]);
    const targetActionId = Number(transformedActionsToLegacyActionsIdMap[dataRouteValue.targetId]);

    const hasMultiLevelAttribute = Boolean(dataRouteValue.attribute.multiLevelAttributeFilter
      ?.filterComponents?.length > 0);
    let multiLevelAttributeFilterComponents = null;
    if (hasMultiLevelAttribute) {
      multiLevelAttributeFilterComponents = reverseTransformMLAAttributeComponents({
        attributeFilterComponents:
          dataRouteValue.attribute.multiLevelAttributeFilter.filterComponents,
        parentType: 'dataRoute',
      });
    }

    const transformedDataRoute: LegacyDataRoute = {
      publicId: dataRouteKey,
      sourceId: sourceActionId,
      targetId: targetActionId,
      source: getActionDataForDataRoute({
        action: sourceAction,
        actionId: sourceActionId,
      }),
      target: getActionDataForDataRoute({
        action: targetAction,
        actionId: targetActionId,
      }),
      id: index + 1,
      category: dataRouteValue.category as { id: number; name: string },
      attribute: {
        id: dataRouteValue.attribute.id,
        attribute_name: dataRouteValue.attribute.attributeName,
        display_name: dataRouteValue.attribute.displayName,
        is_multilevel: hasMultiLevelAttribute,
        multi_level_attribute_filter: {
          filter_components: multiLevelAttributeFilterComponents,
        },
        name: dataRouteValue.attribute.displayName,
      },
      aggregationComponents: [],
      target_payload_key: dataRouteValue.target_payload_key ?? null,
    };

    transformedLegacyDataRoutes.push(transformedDataRoute);
    transformedDataRoutesToLegacyDataRoutesIdMap[dataRouteKey] = transformedDataRoute.id;
  });

  return {
    transformedLegacyDataRoutes,
    transformedDataRoutesToLegacyDataRoutesIdMap,
  };
}
